import { docs_getLinksGroupByDates_Api } from 'apis'
import React from 'react'
import EntityList from 'views/AppLocals/EntityList'
import { bindQueryParams } from 'views/AppLocals/functions/routerHelper'
import { renderIf } from 'views/Shared'
import { CodiLinkTypes } from '../components/Codi/CodiDocumentLinks'
import { renderRowDetailLink } from '../components/Codi/CodiRowDetailLinks'

const CodiRowInstruction = ({
  id,
  type,
  style,
  className,
  header = null,
  related_type = CodiLinkTypes.INSTRUCTION.value,
}) =>
  renderIf(
    related_type,
    <div
      style={style}
      className={className}>
      {header}
      <EntityList
        key={[id, type]}
        RenderEntity={React.Fragment}
        renderItem={renderRowDetailLink}
        apiInfo={docs_getLinksGroupByDates_Api}
        query={bindQueryParams([{ id }, { type }, { related_type }])}
      />
    </div>
  )

export default CodiRowInstruction
